// Importaciones necesarias de React
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Importación del componente principal y estilos
import App from './App.tsx';
import './index.css';

// Constantes de seguridad
const SAFE_ERROR_STYLES = `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ff4444;
  color: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 80%;
  text-align: center;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
`;

function initializeApp() {
  try {
    // Sanitizar el entorno
    if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'production') {
      throw new Error('Ambiente no válido');
    }

    // Obtener el elemento raíz donde se montará nuestra aplicación
    const elementoRaiz = document.getElementById('root');

    if (!elementoRaiz) {
      throw new Error(
        'No se encontró el elemento root en el DOM. ' +
        'Asegúrate de que exista un elemento con id="root" en el archivo index.html'
      );
    }

    // Verificar que el elemento sea seguro para montar la aplicación
    if (elementoRaiz.hasAttribute('data-compromised') || 
        elementoRaiz.querySelector('script')) {
      throw new Error('El elemento root no es seguro para montar la aplicación');
    }

    const root = createRoot(elementoRaiz);
    
    // Envolver la aplicación en StrictMode para detectar problemas potenciales
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );

    // Log de inicialización exitosa (solo en desarrollo)
    if (process.env.NODE_ENV === 'development') {
      console.log('Aplicación inicializada correctamente');
    }
  } catch (error) {
    // Manejo seguro de errores
    console.error('Error al inicializar la aplicación:', 
      error instanceof Error ? error.message : 'Error desconocido'
    );
    
    // Mostrar mensaje de error al usuario de manera segura
    const errorElement = document.createElement('div');
    errorElement.style.cssText = SAFE_ERROR_STYLES;
    errorElement.textContent = 'Ha ocurrido un error al cargar la aplicación. Por favor, recarga la página.';
    
    // Asegurar que el elemento de error sea seguro
    errorElement.setAttribute('role', 'alert');
    errorElement.setAttribute('aria-live', 'assertive');
    
    // Limpiar cualquier contenido existente por seguridad
    const body = document.body;
    while (body.firstChild) {
      body.removeChild(body.firstChild);
    }
    
    body.appendChild(errorElement);
  }
}

// Iniciar la aplicación de manera segura
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}
